export const getRecentSearches = (state) => state.recentSearches;
